/**
 * SLOBurnWidget — shows error budget gauge for a specific SLO.
 */

import { useEffect, useState } from "react";
import { ErrorBudgetGauge } from "../../atoms/ErrorBudgetGauge";
import { apiFetch } from "../../../lib/config";

interface ErrorBudget {
  budget_consumed_percent: string;
  budget_remaining_minutes: number;
  uptime_percent: string;
}

interface Props {
  config: Record<string, unknown>;
}

export function SLOBurnWidget({ config }: Props) {
  const sloId = (config.slo_id as string) ?? "";
  const [budget, setBudget] = useState<ErrorBudget | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!sloId) {
      setLoading(false);
      return;
    }
    apiFetch(`/api/v1/slo/${sloId}/budget/`)
      .then((r) => {
        if (!r.ok) throw new Error(`${r.status}`);
        return r.json();
      })
      .then((d: ErrorBudget) => setBudget(d))
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [sloId]);

  if (loading) return <div className="aptean-widget-skeleton" style={{ height: 120, width: 120 }} />;
  if (error) return <p style={{ color: "var(--aptean-error, #e74c3c)", margin: 0 }}>Error: {error}</p>;
  if (!sloId) return <p style={{ color: "var(--aptean-text-secondary)", margin: 0 }}>Configure SLO ID.</p>;
  if (!budget) return <p style={{ color: "var(--aptean-text-secondary)", margin: 0 }}>No budget data.</p>;

  return (
    <ErrorBudgetGauge
      consumedPercent={parseFloat(budget.budget_consumed_percent)}
      remainingMinutes={budget.budget_remaining_minutes}
      targetPercent={parseFloat(budget.uptime_percent)}
    />
  );
}
